import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@mui/material';
import { DatePicker as MuiDatePicker } from '@mui/lab';

const DatePicker = (props) => {
	const { value,
		onChange,
		size,
		...rest } = props;

	const [open, setOpen] = useState(false);

	return (
		<MuiDatePicker
			open={open}
			onOpen={() => setOpen(true)}
			onClose={() => setOpen(false)}
			renderInput={(p) => (
				<TextField
					{...p}
					fullWidth
					size={size}
					onClick={(e) => setOpen(true)}
					{...rest}
				/>
			)}
			inputFormat="yyyy-MM-DD"
			value={value || null}
			onChange={onChange}
			variant="inline"
			inputVariant="outlined"
			emptyLabel=""
			{...rest}
		/>
	);
};

DatePicker.propTypes = {
	value: PropTypes.any.isRequired,
	onChange: PropTypes.func.isRequired,
	size: PropTypes.string,
};

export default DatePicker;
